import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr, locationHandle, isWx, loadScript } from "@/utils/utils";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import VueAudio from 'vue-audio';
// import 'vue-audio-player/dist/vueaudioplayer.css'
import axios from 'axios';
import 'ol/ol.css';
import { Map, View } from 'ol';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
import Projection from 'ol/proj/Projection';
import SourceImagestatic from 'ol/source/ImageStatic';
import { defaults } from 'ol/control';
import { getCenter } from 'ol/extent';
import Feature from 'ol/Feature';
import { Circle, Point, LineString, GeometryCollection } from 'ol/geom';
import Style from 'ol/style/Style';
import StyleIcon from 'ol/style/Icon';
import StyleText from 'ol/style/Text';
import StyleFill from 'ol/style/Fill';
import StyleStroke from 'ol/style/Stroke';
import { getWidth, boundingExtent } from 'ol/extent';
import { getLength } from 'ol/sphere';
import { DEVICE_PIXEL_RATIO } from 'ol/has';
import { getPan, getPinchRotate, getdragPan } from '@/view/map/js/common';
export default {
  name: 'yujipop',
  data() {
    return {
      query: '',
      popLeftArr: [{
        name: '简介',
        id: 0
      }, {
        name: '图谱',
        id: 1
      }],
      popLeftIndex: 0,
      linkcontainerflag: false,
      iframeurl: '',
      infoList: [],
      videoitem: '',
      videoitemflag: false,
      daohangflag: false,
      staticimgflag: true,
      map: '',
      scatterData: [{
        coordinate: [460, 250],
        fontSize: 26
      }, {
        coordinate: [600, 420],
        fontSize: 20,
        rotation: -Math.PI / 3.6,
        len: 'little'
      }, {
        coordinate: [820, 390],
        fontSize: 20,
        rotation: -Math.PI / 8.3
      }, {
        coordinate: [780, 250],
        fontSize: 20,
        rotation: 0
      }, {
        coordinate: [820, 110],
        fontSize: 20,
        rotation: Math.PI / 8.3
      }, {
        coordinate: [600, 80],
        fontSize: 20,
        rotation: Math.PI / 3.6,
        len: 'little'
      }, {
        coordinate: [320, 80],
        fontSize: 20,
        rotation: -Math.PI / 3.6,
        len: 'little'
      }, {
        coordinate: [100, 110],
        fontSize: 20,
        rotation: -Math.PI / 8.3
      }, {
        coordinate: [140, 250],
        fontSize: 20,
        rotation: 0
      }, {
        coordinate: [100, 390],
        fontSize: 20,
        rotation: Math.PI / 8.3
      }, {
        coordinate: [320, 420],
        fontSize: 20,
        rotation: Math.PI / 3.6,
        len: 'little'
      }],
      iconSource: '',
      iconLayer: '',
      paogif: 'https://p.ananas.chaoxing.com/star3/origin/9a19a8de4477651a08fbb04758ad5134.gif',
      grd: 'rgba(38, 131, 170, 1)',
      atlasdata: []
    };
  },
  components: {
    VueAudio
  },
  watch: {
    '$attrs.detail'(val) {
      if (val.id) {
        this.getAtlasList(val.id);
      }
    },
    '$attrs.detail.banner'(val) {
      if (val) {
        this.$nextTick(() => {
          this.swiperEl = new Swiper(this.$refs.swipercontainer, {
            initialSlide: 0,
            slidesPerView: this.$attrs.isMobile ? 1 : 3,
            autoplay: true,
            speed: 500,
            spaceBetween: this.$attrs.isMobile ? 0 : 10,
            observeSlideChildren: true,
            observeParents: true,
            observer: true
          });
        });
      }
    },
    '$attrs.detail.audio'(val) {
      if (val && val.length > 0) {
        let isHasaudio = this.popLeftArr.find(item => {
          return item.id === 3;
        });
        if (!isHasaudio) this.popLeftArr.push({
          name: '音频',
          id: 3
        });
      }
    },
    '$attrs.detail.video'(val) {
      if (val && val.length > 0) {
        let isHasvideo = this.popLeftArr.find(item => {
          return item.id === 2;
        });
        if (!isHasvideo) this.popLeftArr.push({
          name: '视频',
          id: 2
        });
      }
    }
  },
  created() {
    isWx().then(type => {
      this.daohangflag = type === 'mini-wx' ? false : true;
    });
    loadScript(`${process.env.NODE_ENV === 'development' ? '/fileapi' : location.origin}/frontendTest1/openlayers/js/gifler.min.js`);
  },
  mounted() {
    this.query = this.$route.query;
  },
  methods: {
    // 统一换地址
    sethandleHttp(url) {
      return handleHttp(url);
    },
    // 关闭事件
    closePop() {
      this.$emit('closeHandle');
      this.popshowflag = false;
      this.popLeftIndex = 0;
      this.closevideoItem();
    },
    closevideoItem() {
      this.videoitemflag = false;
      this.videoitem = '';
    },
    // 弹窗左边点击事件
    popLeftHandle(id) {
      this.popLeftIndex = id;
    },
    // 返回事件
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = '';
    },
    goLocation(url) {
      console.log(this.$attrs.detail);
      this.$attrs.detail.linkTarget = '否';
      locationHandle.call(this, this.$attrs.detail, url);
    },
    // 跳转
    goLink(url) {
      this.linkcontainerflag = true;
      this.iframeurl = url;
      // 若选择打开新窗口处理
      // if (this.$attrs.detail.linkTarget !== undefined && this.$attrs.detail.linkTarget === '是') {
      //     window.open(url)
      // } else {
      //     this.linkcontainerflag = true
      //     this.iframeurl = url
      // }
    },
    // 跳转发现
    gofind() {
      axios({
        url: `https://wly-backend.chaoxing.com/api/micro-backend/front/fx/search?fid=${this.query.fid}&formId=1623177&sw=${this.$attrs.detail.place_name}&account=slbwg`,
        method: 'get'
      }).then(res => {
        console.log('跳转发现', res);
        if (res.data.url) {
          window.open(res.data.url);
          // this.linkcontainerflag = true
          // this.iframeurl = res.data.url
        }
      });
    },
    // 获取点位相关图谱数据
    getAtlasList(id) {
      axios({
        url: `https://culture.chaoxing.com/sync/shuili_bwg?id=${id}`,
        method: 'get'
      }).then(res => {
        console.log('图谱信息', res);
        this.atlasdata = res.data.data;
        this.initMap();
      });
    },
    // 加载图谱地图
    initMap() {
      let that = this;
      let extent = [0, 0, 920, 500];
      let projection = new Projection({
        projection: 'EPSG:4326',
        code: 'xkcd-image',
        units: 'pixels',
        extent: extent
      });
      this.iconSource = new VectorSource();
      this.iconLayer = new VectorLayer({
        source: this.iconSource
      });
      console.log(`atlasmap`, this.$refs[`atlasmap`]);
      this.map = new Map({
        layers: [this.iconLayer],
        target: this.$refs[`atlasmap`],
        view: new View({
          projection: projection,
          center: getCenter(extent),
          zoom: 2,
          minZoom: 0,
          maxZoom: 10
        })
      });
      this.map.on('pointermove', this.markermove);
      this.map.on('click', this.markerclick);
      getPan(this.map);
      getdragPan(this.map);
      this.getGradient(this.scatterData);
      this.map.renderSync();
      let linepath = [];
      this.scatterData.forEach((elem, index) => {
        let name = index === 0 ? this.$attrs.detail.place_name : this.atlasdata[index - 1].name;
        let pointfeature = new Feature({
          geometry: new Point(elem.coordinate),
          id: index === 0 ? index : this.atlasdata[index - 1].id,
          name: name,
          image: elem.image,
          type: 'atlas'
        });
        // 标题 一行最多显示4个字符， 最多显示两行8个字符，超过8个字符则省略
        if (name.length > 5) {
          name = name.replace(/(.{5})/g, '$1\n');
          if (name.length > 10) name = name.slice(0, 9) + '...';
        }
        this.addgifFeature(elem, pointfeature, name, index);
        this.iconSource.addFeature(pointfeature);
        if (index > 0) {
          let path = [];
          let p1 = this.scatterData[0].coordinate;
          let p2 = elem.coordinate;
          let dis = this.getDistance(p1, p2);
          let start = this.getLengtnPoint(p1, p2, 90);
          let end = this.getLengtnPoint(p1, p2, dis - 65);
          path.push(start);
          path.push(end);
          const lineString = new LineString(path);
          let linefeature = new Feature({
            type: 'line',
            geometry: lineString
          });
          linefeature.setStyle(new Style({
            stroke: new StyleStroke({
              width: 2,
              color: this.grd
            })
          }));
          this.iconSource.addFeature(linefeature);
          const lineLabelfeature = lineString.getCoordinateAt(0.5);
          let linelabel = new Feature({
            type: 'label',
            geometry: new Point(lineLabelfeature)
          });
          let linetext = this.atlasdata[index - 1].type.join('、');
          let linetextlen = linetext.length;
          let offsetY = -10;
          if (elem.len && elem.len === 'little') {
            linetext = linetext.length > 10 ? linetext.replace(/(.{7})/g, '$1\n') : linetext.replace(/(.{6})/g, '$1\n');
            switch (linetextlen) {
              case 14:
                offsetY = 7;
                break;
              case 11:
                offsetY = 4;
                break;
              case 8:
                offsetY = 0;
                break;
              default:
                offsetY = -10;
                break;
            }
          }
          linelabel.setStyle(new Style({
            text: new StyleText({
              text: linetext,
              fill: new StyleFill({
                color: 'rgba(38, 131, 170, 1)'
              }),
              font: `12px sans-serif`,
              offsetY: offsetY,
              // 偏移量，使文本在线段上方
              textAlign: 'center',
              // 文本对齐方式
              placement: 'line',
              // 文本放置位置
              rotation: elem.rotation
            })
          }));
          this.iconSource.addFeature(linelabel);
        }
      });
    },
    addgifFeature(elem, pointfeature, name, index) {
      let that = this;
      let timer = setInterval(() => {
        if (gifler) {
          const gifUrl = handleHttp(this.paogif);
          const gif = gifler(gifUrl);
          gif.frames(document.createElement('canvas'), function (ctx, frame) {
            if (!pointfeature.getStyle()) {
              pointfeature.setStyle([new Style({
                image: new StyleIcon({
                  img: ctx.canvas,
                  opacity: 1,
                  imgSize: [frame.width, frame.height],
                  scale: index === 0 ? 1 : 0.6
                })
              }), new Style({
                text: new StyleText({
                  textAlign: 'center',
                  text: name,
                  font: `${elem.fontSize}px bold sans-serif`,
                  offsetY: name.length > 5 ? 6 : 1,
                  fill: new StyleFill({
                    color: '#045578'
                  })
                })
              })]);
            }
            ctx.clearRect(0, 0, frame.width, frame.height);
            ctx.drawImage(frame.buffer, frame.x, frame.y);
            that.map.render();
          }, true);
          clearInterval(timer);
        }
      }, 100);
    },
    getGradient(data) {
      let paths = [];
      data.forEach(elem => {
        paths.push(elem.coordinate);
      });
      const lineString = new LineString(paths);
      const extent = lineString.getExtent();
      console.log(`extent`, extent);
      let canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      let minLon = extent[0];
      let maxLon = extent[2];
      let minLat = extent[1];
      let maxLat = extent[3];
      let resolution = this.map.getView().getResolution();
      const pixelRatio = DEVICE_PIXEL_RATIO;
      let height = (maxLat - minLat) / resolution * pixelRatio;
      let width = (maxLon - minLon) / resolution * pixelRatio;
      canvas.width = width;
      canvas.height = height;
      let radius = Math.max(height, width);
      console.log(`radius`, radius);
      let FromCoordinate = [(minLon + maxLon) / 2, (maxLat + minLat) / 2];
      let that = this;
      this.map.once('postrender', () => {
        let center = that.map.getPixelFromCoordinate(FromCoordinate);
        center = [460, 250];
        console.log(`center`, center);
        let gradient = context.createRadialGradient(center[0], center[1], radius / 8, center[0], center[1], radius / 2.5);
        let mainColor = 'rgba(38, 131, 170, 0)';
        let secondColor = 'rgba(38, 131, 170, 1)';
        gradient.addColorStop(0, mainColor);
        gradient.addColorStop(1, secondColor);
        that.grd = gradient;
      });
    },
    getDistance(point1, point2) {
      const dx = point2[0] - point1[0];
      const dy = point2[1] - point1[1];
      return Math.sqrt(dx * dx + dy * dy);
    },
    getLengtnPoint(A, B, L) {
      //求直线斜率
      if (B[0] == A[0] && B[0] == 0) {
        let Dz = A[1] + L;
        let Dx = 0;
        return {
          Dx,
          Dz
        };
      }
      let k = (B[1] - A[1]) * 1.0 / (B[0] - A[0]);
      let b = B[1] - k * B[0];

      // 第二步：求得在直线y=kx+b上，距离当前坐标距离为L的某点
      let H = Math.pow(k, 2) + 1; // A=k^2+1
      let I = 2 * ((b - A[1]) * k - A[0]); // B=2[(b-y0)k-x0]
      let J = Math.pow(b - A[1], 2) + Math.pow(A[0], 2) - Math.pow(L, 2);
      let Dx1 = (-I + Math.sqrt(Math.pow(I, 2) - 4 * H * J)) / (2 * H);
      let Dx2 = (-I - Math.sqrt(Math.pow(I, 2) - 4 * H * J)) / (2 * H);
      let Dx = 0; // 最后确定是在已知两点之间的某点

      // 在向量AB方向上的D点
      if (B[0] - A[0] > 0 && Dx1 - A[0] > 0 || B[0] - A[0] > 0 && Dx1 - A[0] > 0) {
        Dx = Dx1;
      } else {
        Dx = Dx2;
      }
      let Dz = k * Dx + b;
      return [Dx, Dz];
    },
    markermove(evt) {
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      document.body.style.cursor = 'default';
      if (feature === undefined) return;
      // 判断feature类型
      let gtype = feature.getGeometry().getType();
      // point显示弹窗详情
      if (gtype === 'Point') {
        document.body.style.cursor = 'pointer';
      }
    },
    markerclick(evt) {
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      if (feature === undefined) return;
      if (feature.get('type') === 'atlas') {
        this.popLeftIndex = 0;
        let mapdom = this.$refs.atlasmap;
        while (mapdom.firstChild) {
          mapdom.removeChild(mapdom.firstChild);
        }
        this.iconSource.clear();
        this.$emit('atlasmarkerclick', feature);
      }
    }
  }
};